module.exports = __webpack_public_path__ + "static/images/components/Popover/images/arrow-top.4c420dd0.png";


//////////////////
// WEBPACK FOOTER
// ./components/Popover/images/arrow-top.png
// module id = 2657
// module chunks = 11